import { useCallback } from "react"
import * as E from "fp-ts/Either"
import { pipe } from "fp-ts/function"
import fetchClientFolderList from "@/app/components/folder/_fetch/fetchClientFolderList"
import fetchClientSelectedFolderList from "../_fetch/fetchClientSelectedFolderList"
import { useSelectedFolderStore } from "../store/useSelectedFolderStore"

type UseFolderListParams = {
  id?: string
  mode?: "SENTENCE_WRITE" | "SENTENCE_EDIT" | "FOLDERING" | "STORAGE"
}

const useFolderList = ({ id, mode }: UseFolderListParams = {}) => {
  const {
    folders,
    selectedFolders,
    setFolderData,
    hasFoldering,
    clearSelectedFolders,
    addSelectedFolder,
    isSelected,
  } = useSelectedFolderStore()

  const fetch = useCallback(async () => {
    const result = await fetchClientFolderList(300)
    clearSelectedFolders()

    // 문장 스크랩 시 {id: sentenceId} 가 들어옴
    if (id) {
      // 스크랩 혹은 문장 수정시 id가 들어옴
      const folders: string[] = pipe(
        await fetchClientSelectedFolderList(id),
        E.match(
          () => [],
          (v) => v.map((x) => x.folderId),
        ),
      )
      addSelectedFolder(folders)
    }

    return pipe(
      result,
      E.match(
        () => null,
        (res) => {
          // 문장쓰기/수정 또는 폴더링 시 SYSTEM_MIGRATION 폴더 제외
          const shouldFilterMigration =
            id || mode === "SENTENCE_WRITE" || mode === "SENTENCE_EDIT"
          const filteredItems = shouldFilterMigration
            ? res.items.filter((item) => item.folderType !== "SYSTEM_MIGRATION")
            : res.items
          setFolderData(filteredItems)
          return filteredItems
        },
      ),
    )
  }, [id, mode, setFolderData, addSelectedFolder, clearSelectedFolders])

  return {
    folders,
    selectedFolders,
    hasFoldering,
    isSelected,
    fetch,
  }
}

export default useFolderList
